"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreviewModule = void 0;
var preview_references_const_1 = require("./preview-references.const");
var PreviewModule = /** @class */ (function () {
    function PreviewModule() {
        this.settings = {};
        this.originalDisplay = 'block';
        this.isConfirming = false;
    }
    PreviewModule.prototype.loadModule = function () {
        return __awaiter(this, void 0, void 0, function () {
            var btn_1, btn;
            var _this = this;
            var _a, _b;
            return __generator(this, function (_c) {
                this.originalDisplay = this.$container.get(0).style.display;
                this.$container.get(0).style.display = 'none';
                this.confirmButton = this.$container.find("[data-action=\"".concat(preview_references_const_1._PreviewReferences.confirmPreview.uid, "\"]"));
                if ((_a = this.confirmButton) === null || _a === void 0 ? void 0 : _a.length) {
                    btn_1 = this.confirmButton[0];
                    btn_1.addEventListener('click', function () { return __awaiter(_this, void 0, void 0, function () {
                        var _a;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0:
                                    if (this.isConfirming)
                                        return [2 /*return*/];
                                    this.isConfirming = true;
                                    btn_1.disabled = true;
                                    btn_1.setAttribute('data-allow-action', 'false');
                                    _b.label = 1;
                                case 1:
                                    _b.trys.push([1, , 3, 4]);
                                    return [4 /*yield*/, ((_a = this.onConfirmPreview) === null || _a === void 0 ? void 0 : _a.call(this))];
                                case 2:
                                    _b.sent();
                                    return [3 /*break*/, 4];
                                case 3:
                                    this.isConfirming = false;
                                    btn_1.disabled = false;
                                    btn_1.setAttribute('data-allow-action', 'true');
                                    return [7 /*endfinally*/];
                                case 4: return [2 /*return*/];
                            }
                        });
                    }); });
                }
                this.cancelButton = this.$container.find("[data-action=\"".concat(preview_references_const_1._PreviewReferences.cancelPreview.uid, "\"]"));
                if ((_b = this.cancelButton) === null || _b === void 0 ? void 0 : _b.length) {
                    btn = this.cancelButton[0];
                    btn.addEventListener('click', function () { return __awaiter(_this, void 0, void 0, function () {
                        var _a;
                        return __generator(this, function (_b) {
                            this.$container.get(0).style.display = 'none';
                            (_a = this.onCancelPreview) === null || _a === void 0 ? void 0 : _a.call(this);
                            return [2 /*return*/];
                        });
                    }); });
                }
                return [2 /*return*/];
            });
        });
    };
    PreviewModule.prototype.loadPreview = function (data) {
        var _a;
        this.isConfirming = false;
        if ((_a = this.confirmButton) === null || _a === void 0 ? void 0 : _a.length) {
            var btn = this.confirmButton[0];
            btn.disabled = false;
            btn.setAttribute('data-allow-action', 'true');
        }
        this.$container.get(0).style.display = this.originalDisplay || 'block';
        var getter = this.$container.get(0).querySelectorAll('[data-get]');
        if (getter === null || getter === void 0 ? void 0 : getter.length) {
            getter.forEach(function (a) {
                var _a;
                var attr = a.getAttribute('data-get');
                if (!attr)
                    return;
                a.textContent = (_a = data[attr]) !== null && _a !== void 0 ? _a : '';
            });
        }
    };
    return PreviewModule;
}());
exports.PreviewModule = PreviewModule;
